var _path;
import * as React from "react";
var SvgStats = function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6a2 2 0 0 1-2.327 1.973l-4.834 5.74a2 2 0 1 1-3.83.587l-2.485-1.582a1.991 1.991 0 0 1-1.65.182L4.4 16.373A2 2 0 1 1 3.127 15.1L6.6 11.627a2 2 0 1 1 3.89-.427l2.486 1.582a1.991 1.991 0 0 1 1.486-.228l4.755-5.647A2 2 0 1 1 23 6Z"
  })));
};
export default SvgStats;